const $ = require('jquery')

module.exports = (function () {
  /*
   * スクロールに応じて処理を行う補助プラグイン
   * $(".your-class").scrollNavController({
   *    scroll   : function(){},
   *    noScroll : function() {}
   * });
   */
  $.fn.extend({
    scrollNavController: function (callbacks) {
      if (!$(this).length) {
        return
      }

      const that = this
      const navOffset = $(this).offset().top

      $(window).on('scroll load', function () {
        const nowOffset = $(window).scrollTop()
        if (nowOffset >= navOffset) {
          callbacks.scroll.call(that)
        } else {
          callbacks.noScroll.call(that)
        }
      })
    }
  })
})()
